module.exports = __webpack_public_path__ + "img/en04.c42228e6.png";